import React from "react";
import { Card, Col, Descriptions, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";

const CompanyField = ({ mode, companyCode }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const isViewMode = mode === "VIEW";

  if (isViewMode) {
    const company = form.getFieldValue(["companies", companyCode, "company"]) || {};

    return (
      <Row gutter={16}>
        <Col span={24}>
          <Card>
            <Descriptions column={{ xs: 1, sm: 2, md: 2 }} bordered size="small">
              <Descriptions.Item label={t("countries.company_name")}>{company.name || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.street")}>{company.street || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.zip_code")}>{company.zipCode || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.city")}>{company.city || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.house_number")}>{company.houseNumber || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.country")}>{company.country || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.visiting_address")}>
                {company.visitingAddress || "-"}
              </Descriptions.Item>
              <Descriptions.Item label={t("countries.kvk")}>{company.kvk || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.vat_number")}>{company.vat || "-"}</Descriptions.Item>
              <Descriptions.Item label={t("countries.iban")}>{company.iban || "-"}</Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "name"]} label={t("countries.company_name")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={9}>
              <Form.Item name={["companies", companyCode, "company", "street"]} label={t("countries.street")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={3}>
              <Form.Item
                name={["companies", companyCode, "company", "houseNumber"]}
                label={t("countries.house_number")}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "zipCode"]} label={t("countries.zip_code")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "city"]} label={t("countries.city")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "country"]} label={t("countries.country")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name={["companies", companyCode, "company", "visitingAddress"]}
                label={t("countries.visiting_address")}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "kvk"]} label={t("countries.kvk")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "vat"]} label={t("countries.vat_number")}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name={["companies", companyCode, "company", "iban"]} label={t("countries.iban")}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default CompanyField;
